import { Typography, Box, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

import { LineBadgesItem } from './LineBadgesItem';
import { LineIconItem } from './LineIconItem';
import { LinePillsItem } from './LinePillsItem';
import {
  STAT_ROW_BREAKPOINT,
  StatRowStyle,
  statRowMainSx,
  statRowSx,
  statRowStatsSx,
} from './statColumnLayout';
import { ScoopSummaryItem, ScoopStatItem } from './types';

type TheScoopProps = Readonly<{
  summaryItems: ScoopSummaryItem[];
  statItems: ScoopStatItem[];
}>;

export const TheScoop = ({ summaryItems, statItems }: TheScoopProps) => {
  return (
    <Box sx={statRowSx}>
      <Box sx={[summaryContainerSx, statRowMainSx]}>
        {summaryItems.map((item, index) => (
          <Box key={index}>
            {item.title && (
              <Typography
                variant="text-md-bold"
                component="span"
                color={({ backrs }) => backrs.colors['Brand/500']}
              >
                {item.title}:{' '}
              </Typography>
            )}
            <Typography variant="text-md-regular" component="span">
              {item.description}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box sx={[statRowStatsSx, statsInfoContainerSx]}>
        {statItems.map((item, index) => renderStatItem(item, index))}
      </Box>
    </Box>
  );
};

const renderStatItem = (item: ScoopStatItem, index: number): React.ReactNode => {
  switch (item.kind) {
    case 'text':
      if (!item.text) return null;

      return (
        <LineIconItem
          key={index}
          title={item.title}
          iconName={item.iconName}
          text={item.text}
          info={item.info}
        />
      );
    case 'pills':
      if (item.pills.length === 0) return null;

      return <LinePillsItem key={index} title={item.title} pills={item.pills} info={item.info} />;
    case 'badges':
      if (item.badges.length === 0) return null;

      return (
        <LineBadgesItem key={index} title={item.title} badges={item.badges} info={item.info} />
      );
  }
};

const summaryContainerSx: StatRowStyle = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-2xl'],
});

const statsInfoContainerSx: SystemStyleObject<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  [STAT_ROW_BREAKPOINT]: {
    display: 'flex',
  },
};
